module.exports = __webpack_public_path__ + "img/horizontal_3_3_pp3_9005.9c06fff7.png";